
export default {
  init() {
    // JavaScript to be fired on pages that use the alternating section layout
    $(document).ready(function () {
        $('.has-active-border').each(function (){


          let border = $(this).find('div.nav-active-border'),
            tabItem = $(this).find('li a')

          tabItem.click( function() {
            activeBorder($(this))
          })

          function activeBorder(item) {

              if (item.parent().is(':visible')) {
                let leftPos = item.parent().position().left ,
                  // topPos = item.parent().position().top,
                  widthPos = item.parent().width() + 10
                // heightPos = item.innerHeight()
                console.log(widthPos)

                border.css({
                  'left': leftPos,
                  'width': widthPos,
                  // 'top': topPos+heightPos,
                })
              }
          }
          $(window).on('resize', function () {
            activeBorder($(this).find('li.uk-active a'))
          })

        // setTimeout(function() {
          activeBorder($(this).find('li.uk-active a'));
        // }, 1000)
        });

    })
  },
  finalize() {
    // JavaScript to be fired on pages that use the alternating section layout, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/secondaryPageNav.js